@if (loading) {
  <p class="empty">{{ 'admin.features.loading' | adminTranslate }}</p>
} @else {
  <div class="groups">
    @for (group of groupedFeatures; track group.groupKey) {
      <section class="group">
        <div class="group__header">
          <h3 [id]="'feature-group-' + group.groupKey">{{ group.groupKey | adminTranslate }}</h3>
        </div>

        <div class="feature-table-wrap" tabindex="0" role="region" [attr.aria-labelledby]="'feature-group-' + group.groupKey">
          <table class="feature-table">
            <thead>
              <tr>
                <th>{{ 'admin.features.table.feature' | adminTranslate }}</th>
                <th>{{ 'admin.features.table.route' | adminTranslate }}</th>
                <th>{{ 'admin.features.table.status' | adminTranslate }}</th>
                <th>{{ 'admin.features.table.updatedAt' | adminTranslate }}</th>
                <th>{{ 'admin.features.table.actions' | adminTranslate }}</th>
              </tr>
            </thead>
            <tbody>
              @for (feature of group.items; track feature.key) {
                <tr>
                  <td>
                    <div class="feature-cell-main">
                      <strong>{{ feature.titleKey | adminTranslate }}</strong>
                      <p>{{ feature.descriptionKey | adminTranslate }}</p>
                    </div>
                  </td>
                  <td>
                    <span class="feature-table__route">{{ feature.route }}</span>
                  </td>
                  <td>
                    <span class="status-pill" [class.status-pill--enabled]="currentStatus(feature.key) === 'ENABLED'" [class.status-pill--disabled]="currentStatus(feature.key) === 'DISABLED'" [class.status-pill--coming-soon]="currentStatus(feature.key) === 'COMING_SOON'">
                      {{ statusLabel(currentStatus(feature.key)) | adminTranslate }}
                    </span>
                  </td>
                  <td>
                    @if (flagsByKey[feature.key]?.updatedAt) {
                      <span class="feature-table__updated-at">
                        {{ flagsByKey[feature.key].updatedAt | date:'dd/MM/yyyy HH:mm' }}
                      </span>
                    } @else {
                      <span class="feature-table__updated-at feature-table__updated-at--empty">-</span>
                    }
                  </td>
                  <td>
                    <div class="feature-table__actions">
                      @for (status of statuses; track status) {
                        <ui-button
                          size="sm"
                          [variant]="isStatusActive(feature.key, status) ? 'primary' : 'secondary'"
                          [disabled]="isSaving(feature.key) || !flagsByKey[feature.key]"
                          (click)="updateFeatureFlag(feature.key, status)">
                          {{ statusLabel(status) | adminTranslate }}
                        </ui-button>
                      }
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </section>
    }
  </div>
}
